module.exports = __webpack_public_path__ + "img/lol.fe04f9e0.png";